import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-bonificacao-filtro',
  templateUrl: './bonificacao-filtro.component.html',
  styleUrls: ['./bonificacao-filtro.component.css']
})
export class BonificacaoFiltroComponent implements OnInit {

  @Input() filtros: any;

  constructor() { }

  ngOnInit() {
  }
}
